import React from 'react';
import {Navigate, useLocation, useParams} from 'react-router';

/** Redirect legacy `/rfi/*` paths to `/icr/*` (preserves path suffix, search, hash). */
export default function LegacyRfiRedirect() {
    const {'*': rest} = useParams();
    const location = useLocation();
    const base = rest ? `/icr/${rest}` : '/icr';
    return <Navigate to={`${base}${location.search}${location.hash}`} replace/>;
}
